__turbopack_context__.v({
  "searchSuggestionsContainer": "_3WWifG_searchSuggestionsContainer",
  "searchSuggestionsContainer--fullViewPort": "_3WWifG_searchSuggestionsContainer--fullViewPort",
  "searchSuggestionsContainer--variant": "_3WWifG_searchSuggestionsContainer--variant",
  "searchSuggestionsContainer--verticalPadding": "_3WWifG_searchSuggestionsContainer--verticalPadding",
  "suggestionClearButton": "_3WWifG_suggestionClearButton",
  "suggestionListHeader": "_3WWifG_suggestionListHeader",
  "suggestionTitle": "_3WWifG_suggestionTitle",
});
